// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3ERfl","spindlLogo":"Header_spindlLogo__RGe4m","headerContent":"Header_headerContent__3ygbm"};